import React from "react"

import { styled } from "@mui/material"

const StyledHeader = styled("section", {
})(({ theme }) => {
  return {
    display: "flex",
    flexDirection: "column",
    "& .partners": {
      display: "flex",
      gap: theme.spacing(2),
      position: "absolute",
      top: 25,
      left: theme.spacing(1.5)
    },
    "& > a#rws": {
      display: "block",
      margin: "auto",
      transform: "translateX(112px)"
    },
    [theme.breakpoints.down("md")]: {
      "& .partners": {
        display: "none",
        visibility: "hidden"
      },
      "& > a#rws": {
        transform: "unset"
      }
    }
  }
})

const Header = (props) => {
  return (
    <StyledHeader className="site-header">
      {props.children}
    </StyledHeader>
  )
}

export default React.memo(Header)